import { ContactsServiceImpl } from "./serviceImpl";

export interface ContactsService {
  updateSendEmails(
    contactId: string,
    sendEmails: string[]): Promise<void>
}

export function NewContactsService(): ContactsService {
  return new ContactsServiceImpl();
}
